<template>
  <div class="column is-12 is-12-desktop">
    <div class="content">
      <h3>Ihre akzeptierten Dokumente</h3>
      <p>Hier können Sie Ihre bereits akzeptieren Dokumente nochmals einsehen</p>

      <ul v-if="sp.campground && sp.campground.legal_documents.accepted">
        <li v-for="doc in sp.campground.legal_documents.accepted" :key="doc.id">
          <h3>
            {{ doc.legal_document.name }}, {{ $t('dashboard.legal_documents.valid_from') }}
            {{ doc.legal_document.valid_from }}
          </h3>
          <div>
            <p>
              {{ doc.legal_document.info_text }}<br>
              Akzeptiert am {{ doc.accepted_at }} von {{ doc.accepted_by }}<br>
              <a :href="doc.legal_document.documents.terms_of_service" target="_blank">
                <span>{{ $t('dashboard.legal_documents.tos') }}</span>
              </a>
              <span> & </span>
              <a :href="doc.legal_document.documents.order_processing_conditions" target="_blank">
                <span>{{ $t('dashboard.legal_documents.opc') }}</span>
              </a>
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'DocumentsTab',
        inject: ['settingsParent'],
        computed: {
            sp() { return this.settingsParent; },
        },
    };
</script>



// WEBPACK FOOTER //
// src/views/components/campground-settings/tabs/DocumentsTab.vue